import axios from '../utils/http'

// 获取图表数据
export const apiAnalysisData = (api, params) => {
    const time = new Date().getTime()
    return axios.get('/data/' + api, {params: {...params, time}})
}

// 获取所有品种
export const apiVarietyList = (params) => {
    const time = new Date().getTime()
    return axios.get('/data/varietyList', {params: {...params, time}})
}

// 获取账户概览
export const apiGeneral = () => {
    const time = new Date().getTime()
    return axios.get('/data/general', {params: time})
}

export const apiDataDownload = (params) => {
    return axios({
        url: '/data/dataDownload',
        method: 'get',
        params: params,
        responseType: 'blob'
    });
}